<template>
  <div id="app">
    <tabs v-model="activeKey" @on-click="handleOnclick" @on-close="handleOnclose">
      
      <pane v-for="item in pans" 
      :key="item.mes"
      :label="item.label"
      :name="item.name"
      :closable="item.closable"
      >
        {{item.mes}}
      </pane>
    </tabs>
  </div>
</template>
<script>
import tabs from './components/tabs';
import pane from './components/pane';
export default {
  components:{
    tabs,
    pane
  },
  data(){
    return{
      activeKey:'1',
      pans:[
        {
          label:'标签一',
          name:'1',
          closable:true,
          mes:'标签一的内容'
        },
        {
          label:'标签二',
          name:'2',
          closable:true,
          mes:'标签二的内容'
        },
        {
          label:'标签三',
          name:'3',
          closable:true,
          mes:'标签三的内容'
        },
      ]
    }
  },

  methods:{
    handleOnclick(name){

    },
    handleOnclose(name){
        var index=0;
        for(var i=0;i<this.pans.length;i++)    {
          if(this.pans[i].name===name){
            index=i;
            break;
          }
        }
        this.pans.splice(index,1);
    }
  },
  beforeDestroy(){
    this.$off('on-click',this.handleOnclick);
    this.$off('on-close',this.handleOnclose);
  }
}
</script>

